import { createContext } from "react";

const BI_AUT001Context = createContext();

export {BI_AUT001Context}